// (A) 중립 DatePicker API — antd 미접촉. (B) PlainDatePicker(native input)에 위임.
// ⚠ 값 계약은 문자열(date: YYYY-MM-DD / showTime: YYYY-MM-DDTHH:mm, native datetime-local).
import type { CSSProperties } from 'react'
import { PlainDatePicker } from '../_impl/PlainDatePicker'

export interface OmwDatePickerProps {
  /** 문자열 값. date: YYYY-MM-DD, showTime: YYYY-MM-DDTHH:mm. 빈 문자열/undefined = 미선택. */
  value?: string
  onChange?: (value: string) => void
  showTime?: boolean
  placeholder?: string
  disabled?: boolean
  className?: string
  style?: CSSProperties
}

export function OmwDatePicker(props: OmwDatePickerProps) {
  return <PlainDatePicker {...props} />
}
